import Color from 'color';
import SharingLinks from 'common/components/sharing-links';
import styles from './styles.less';
import { observer } from 'mobx-react';


function VideoMetadata(props) {
    const className = cx(styles.root, props.className, { [styles.sticky]: props.sticky });
    const textColor = Color(props.backgroundColor).mix(Color(props.color), 0.3);
    const { video } = props;
    return (
        <div
            className={ className }
            style={{ color: textColor.hexString() }}>
            <h2
                className={ styles.collectionTitle }
                style={{ color: props.color }}>
                { video.collectionTitle }
            </h2>
            <h1 className={ styles.title }>{ video.title }</h1>
            <p className={ styles.description }>{ video.description }</p>
            <SharingLinks
                className={ styles.sharingLinks }
                label='Share this Video:'
                linkClassName={ styles.sharingLink }
                url={ video.shareUrl }
            />
            <div className={ styles.metaProps }>
                { !!video.tvRating &&
                <span className={ styles.metaProp }>
                    { video.tvRating }
                </span> }
                { !!video.expirationDateFormatted &&
                <span className={ styles.metaProp }>
                    Expires: { video.expirationDateFormatted }
                </span> }
            </div>
        </div>
    );
}

VideoMetadata.propTypes = {
    backgroundColor: React.PropTypes.string.isRequired,
    color: React.PropTypes.string.isRequired,
    sticky: React.PropTypes.bool,
    video: React.PropTypes.object.isRequired
};

VideoMetadata.defaultProps = {
    backgroundColor: '#333333',
    color: '#FFFFFF',
    sticky: false
};


export default observer(VideoMetadata);



/** WEBPACK FOOTER **
 ** ./src/show-page/components/video-metadata/index.js
 **/